import React, { Component, useState, useEffect } from "react";
//import { Draggable } from "react-drag-reorder";
import { Multiselect } from "multiselect-react-dropdown";
import {
  Row,
  Card,
  Col,
  Button,
  Nav,
  Modal,
  Table,
  Dropdown,
  Alert,
  Spinner,
  Toast
} from "react-bootstrap";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
var FormData = require("form-data");
var fs = require("fs");
export default function Banners() {
  const history=useHistory()
  const [show4, setShow4] = useState(false);
  const [notification, setNotification] = useState({title: '', body: ''});
  const [spinner, setSpinner] = useState(true);
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [color, setColor] = useState("");
  const [description, setDescription] = useState("");
  const [banners, setBanners] = useState("");
  const [bannerId, setBannerId] = useState("");
  const [bannerCategory, setBannerCategory] = useState("");
  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerDescription, setBannerDescription] = useState("");
  const [bannerImage, setBannerImage] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [bannerImageKey, setBannerImageKey] = useState("");
  const [catList, setCatList] = useState([]);
  const handleShow = () => {
    setUpdateStatus(false);
    setShow(true);
    setDeleteStatus(false)
    setUrl('')
    setColor('')
  };
  const handleClose = () => {
    setShow(false);
  };
  function getData() {
    axios.get(Baseurl.baseurl + `/go-ui/get-trending`).then((res) => {
      setSpinner(false)
      setBanners(res.data.trending);
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })
  }
  function getCategory(){
    let cat=[];
    axios.get(Baseurl.baseurl + `/go-ui/get-category`).then((res) => {
      res.data.categories.map((val)=>{
        cat.push({category:val.Category,title:val.Category})
      })
      cat.push({ category: "others", title: "Others" })
      setCatList(cat)
    })
    .catch((err) => {
      if(err.toString()==="Error: Network Error")
      {
        history.push('/offline')
      }
      else
      {
        history.push('/400')
      }
  })

  }
  useEffect(() => {
    getData();
    getCategory()
    // getToken(setTokenFound);
    // onMessageListener().then(payload => {
    //   setShow4(true);
    //   setNotification({title: payload.notification.title, body: payload.notification.body})
    //   console.log(payload);
    // }).catch(err => console.log('failed: ', err));
  
    
  }, []);
  const onChangePicture = (e) => {
    if(e.target.files[0] && e.target.files[0].size/1024<3000){
      
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setImage(e.target.files[0]);
              setImageData(reader.result);
            // if (height == 400 && width == 800) {
            //   setImage(e.target.files[0]);
            //   setImageData(reader.result);
            // }
            // else
            //   {
            //   swal("Oops", "image Width×Height should be 800×400", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setImageData(null);
            // return false;
            // }
          };
        };
      }
    }
    else
    {
      swal("Oops", "image size should be less than 300KB", "error", {
        button: "Done",
        timer: 2000,
      });
      setImageData(null)
    }
   
  };
  const onChangePicture2 = (e) => {
    setUploadStatus(true);
    if(e.target.files[0]&&e.target.files[0].size/1024<3000){
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setImage2(e.target.files[0]);
              setBannerImage(reader.result);
            // if (height == 400 && width == 800) {
            //   setImage2(e.target.files[0]);
            //   setBannerImage(reader.result);
            // }
            // else
            //   {
            //   swal("Oops", "image Width×Height should be 800×400", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setBannerImage(null);
            // return false;
            // }
          };
        };
      }
    }
    else
    {
      swal("Oops", "image size should be less than 300KB", "error", {
        button: "Done",
        timer: 2000,
      });
      setBannerImage(null)
    }
    
  };
  function saveBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("category", `${name}`);
    data.append("title", `${title}`);
    data.append("url", `${url}`);
    data.append("color", `0XFF${color}`);
    data.append("description", `${description}`);
    data.append("image", image);

    var config = {
      method: "post",
      url: `${Baseurl.baseurl}/go-ui/add-trending`,
      data: data,
    };

    axios(config)
      .then(function(response) {
        if (response.data.status) {
          getData();
          setName("");
          setTitle('')
          setUrl('')
          setColor('')
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", { button: "Done",timer: 1000 });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done" ,timer: 1000});
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })

    handleClose();
  }
  function deleteBanner(e) {
    e.preventDefault()
    axios
      .delete(Baseurl.baseurl + `/go-ui/delete-trending-by-id/${bannerId}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", { button: "Done",timer: 1000 });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000 });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
      handleClose();
  }
  const selection2 = (selectedValues) => {
    setName(selectedValues[0].category);
  };
  const selection3 = (selectedValues) => {
    setBannerCategory(selectedValues[0].category);
  };
  function updateBanner(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", image2);
    data.append("trendingImageKey", bannerImageKey);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/go-ui/update-trending-by-id/${bannerId}`,
      data: data,
    };

    axios(config)
      .then(function(response) {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          setUrl('')
          setColor('')
          swal("Added", response.data.message, "success", { button: "Done",timer: 1000 });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000 });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })

    handleClose();
  }
  function updateBannerCategory(e) {
    e.preventDefault();
   
    let bannerData = {
      Category: `${bannerCategory}`,
      Title: `${bannerTitle}`,
      Description: `${bannerDescription}`,
      //Color:`0XFF${color}`,
      Url:url
    };
    axios
      .put(
        Baseurl.baseurl + `/go-ui/update-trending-detail-by-id/${bannerId}`,
        bannerData
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", { button: "Done" ,timer: 1000});
        } else {
          swal("Oops", response.data.message, "error", { button: "Done" ,timer: 1000});
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
    handleClose();
  }
  return (
    <Card>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          {deleteStatus?(
          <h4>
            Are you sure !! you want to delete Trending Banner <text className="text-danger ml-1">{bannerTitle}</text>
          </h4>):(
            <div>
            {updateStatus ? ( 
              <div>
                <div className="basic-form">
                  <form>
                    <div className=" mb-2" id="multiselect">
                      <label>Category</label>
                      <Multiselect
                        closeIcon="close"
                        options={catList}
                        singleSelect
                        displayValue="title"
                        onSelect={selection3}
                        placeholder={`${bannerCategory}`}
                      />
                    </div>
                  </form>
                </div>
                <div className=" mb-3">
                  <label>Title</label>
                  <input
                    value={bannerTitle}
                    type="text"
                    className="form-control"
                    placeholder="enter title"
                    onChange={(e) => setBannerTitle(e.target.value)}
                    required
                  />
                </div>
                <div className=" mb-3">
                  <label>Url</label>
                  <input
                    value={url}
                    type="text"
                    className="form-control"
                    placeholder="enter url"
                    onChange={(e) => setUrl(e.target.value)}
                    required
                  />
                </div>
                {/* <div className=" mb-3">
                  <label>Color</label>
                  <input
                    value={color}
                    type="text"
                    className="form-control"
                    placeholder="enter Color"
                    onChange={(e) => setColor(e.target.value)}
                    required
                  />
                </div> */}
                <div className=" mb-3">
                  <label>Description</label>
                  <input
                    value={bannerDescription}
                    type="text"
                    className="form-control"
                    placeholder="enter description"
                    onChange={(e) => setBannerDescription(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-3 mt-2 mb-4">
                  <button
                    onClick={(e) => {
                      updateBannerCategory(e);
                    }}
                    className="btn btn-primary mt-2"
                  >
                    Add
                  </button>
                </div>
                <div className="col-sm-12">
                  <div className="form-group row">
                    <label
                      className="col-sm-5 col-form-label"
                      htmlFor="val-range"
                    >
                      Trending Banner Image
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-lg-7">
                      <div className="row1">
                        <div classname="col-sm-4">
                          <div className="register_profile_image mt-2">
                            <input
                              id="profilePic"
                              type="file"
                              onChange={(e) => {
                                onChangePicture2(e);
                              }}
                            />
                          </div>
                          <small>image should be less than 300KB and size 800×400</small>
                          {bannerImage && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="previewProfilePic"
                            >
                              <img
                              alt=''
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={bannerImage}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 mt-3">
                  <button
                    onClick={(e) => {
                      updateBanner(e);
                    }}
                    className="btn btn-primary mt-2"
                  >
                    Update Banner
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <div className="basic-form">
                  <form>
                    <div className=" mb-2" id="multiselect">
                      <label>Category</label>
                      <Multiselect
                        closeIcon="close"
                        options={catList}
                        singleSelect
                        displayValue="title"
                        onSelect={selection2}
                      />
                    </div>
                  </form>
                </div>
                <div className=" mb-3">
                  <label>Title</label>
                  <input
                    value={title}
                    type="text"
                    className="form-control"
                    placeholder="enter title"
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className=" mb-3">
                  <label>Url</label>
                  <input
                    value={url}
                    type="text"
                    className="form-control"
                    placeholder="enter url"
                    onChange={(e) => setUrl(e.target.value)}
                    required
                  />
                </div>
                <div className=" mb-3">
                  <label>Color</label>
                  <input
                    value={color}
                    type="text"
                    className="form-control"
                    placeholder="enter Color"
                    onChange={(e) => setColor(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label>Description</label>
                  <input
                    value={description}
                    type="text"
                    className="form-control"
                    placeholder="enter description"
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                </div>
                <div className="col-sm-12">
                  <div className="form-group row">
                    <label
                      className="col-sm-5 col-form-label"
                      htmlFor="val-range"
                    >
                      Trending Banner Image
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-lg-7">
                      <div className="row1">
                        <div classname="col-sm-4">
                          <div className="register_profile_image mt-2">
                            <input
                              id="profilePic"
                              type="file"
                              onChange={(e) => {
                                onChangePicture(e);
                              }}
                            />
                          </div>
                          <small>image should be less than 300KB and size 800×400</small>
                          {imageData && (
                            <div
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                              className="previewProfilePic"
                            >
                              <img
                              alt=''
                                className="playerProfilePic_home_tile"
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                src={imageData}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {
            deleteStatus?(
              <Button
                  variant="primary"
                  onClick={(e) => {
                   deleteBanner(e);
                  }}
                >
                  Delete
                </Button>
            ):(
              <>
              {updateStatus ? null : (
                <Button
                  variant="primary"
                  onClick={(e) => {
                    saveBanner(e);
                  }}
                >
                  submit
                </Button>
              )}
              </>
            )
          }
         
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
      <Toast onClose={() => setShow4(false)} show={show4} delay={3000} autohide animation style={{
          position: 'absolute',
          top: 20,
          right: 20,
          minWidth: 200
        }}>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded mr-2"
              alt=""
            />
            <strong className="mr-auto">{notification.title}</strong>
            <small>just now</small>
          </Toast.Header>
          <Toast.Body>{notification.body}</Toast.Body>
        </Toast>
        
        <div style={{ padding: 20 }} className="flex-container">
          <div>
            <div>
              <button className="btn btn-primary float-right" onClick={handleShow}>
                Add Trending
              </button>
            </div>
            <div>
    
         </div>
            <Table>
              <thead>
                <div className="row">
                  <div className="col-sm-2 ml-2">
                    <strong>Category</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Image</strong>
                  </div>
                  <div className="col-sm-2">
                    <strong>Title</strong>
                  </div>
                  <div className="col-auto">
                    <strong>Description</strong>
                  </div>
                  <div className="col-sm-1">
                    <strong>Color</strong>
                  </div>
              
                </div>
              </thead>
            </Table>

            {
              spinner?(
                <div className="text-center">
             <Spinner  animation="border" variant="primary" />
           </div>
              ):(
                <>
              {banners &&
                banners.map((word) => {
                  return (
                    <Card  style={{
                      color: "white",
                      background:
                        "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
                    }}>
                      <Card.Body>
                        <div className="row">
                            <div className="col-sm-2 mt-4 ">
                              {word.Category ? (
                                <div key={word._id} className="flex-item mt-3">
                                  {word.Category.replace('_',' ')}
                                </div>
                              ) : (
                                <div className="flex-item mt-3">----</div>
                              )}
                            </div>
                            <div className="col-sm-2">
                              <div
                                className="col-sm-12"
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                              >
                                <img
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  class="img-fluid"
                                  alt=""
                                  src={word.Image}
                                />
                              </div>
                            </div>
                            <div className="col-sm-2">{word.Title}</div>
                            <div className="col-sm-2">{word.Description}</div>
                            <div className="col-sm-1 mt-4">
                            <div className="mt-2"  style={{backgroundColor:`#${word.Color.toString(16).slice(2)}`,height:20,width:20}}></div>
                            </div>
                            <div className="mt-4">
                              <button
                                onClick={() => {
                                  setShow(true);
                                  setBannerId(word._id);
                                  setUpdateStatus(true);
                                  setBannerCategory(word.Category);
                                  setBannerTitle(word.Title);
                                  setBannerDescription(word.Description);
                                  setBannerImageKey(word.ImageKey)
                                  setBannerImage(word.Image);
                                  setUrl(word.Url)
                                  setColor(word.Color)
                                  setUploadStatus(false);
                                  setDeleteStatus(false)
                                }}
                                className="btn btn-primary"
                              >
                                Update
                              </button>
                            </div>
                            <div className="mt-4">
                              <button
                                onClick={() => {
                                  setDeleteStatus(true)
                                  setShow(true)
                                  setBannerId(word._id);
                                  setBannerTitle(word.Title);
                                }}
                                className="btn btn-primary ml-2"
                              >
                                delete
                              </button>
                            </div>
                         
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              {!banners && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Add Banners
                </Alert>
              )}
            </>
              )
            }
          </div>
        </div>
      </div>
    </Card>
  );
}
